'use client';

import { useContext } from 'react';

import { EventBatchContext } from '@/providers/EventBatchProvider';

export const useEventBatchContext = () => {
  const context = useContext(EventBatchContext);

  if (!context) {
    throw new Error('useEventBatchContext must be used within an EventBatchProvider');
  }

  return context;
};
